import 'whatwg-fetch';

const apiRoot = 'https://api.music.apple.com/v1';

export default {
  addTrackToPlaylist
};

function addTrackToPlaylist(playlistId, tracks) {
  const developerToken = MusicKit.getInstance().api.developerToken;
  const userToken = MusicKit.getInstance().api.userToken;
  return fetch(`${apiRoot}/me/library/playlists/${playlistId}/tracks`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${developerToken}`,
      'Content-Type': 'application/json',
      'music-user-token': userToken
    },
    body: JSON.stringify({
      data: tracks.map((t) => {
        return { id: t.id, type: t.type };
      })
    })
  });
}
